import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpDownOutlinedSize12Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m2.992 7.132-.742.743L6 11.625l3.75-3.75-.742-.743L6 10.14z"
                    fill="currentColor"
                />
                <path d="m6 .375 3.75 3.75-.742.743L6 1.86 2.992 4.868l-.742-.743z" fill="currentColor" />
            </g>
        </svg>
    )
);
ChevronUpDownOutlinedSize12Glyph.displayName = 'ChevronUpDownOutlinedSize12Glyph';
